// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.navbar {
  position: relative;
  width: 100%;
  z-index: 3000;
  background: transparent;
  border-radius: 0 0 20px 20px;
  overflow: visible;
}
.navbar.scrolled {
  background: rgba(200, 200, 200, 0.93);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
}
.navbar {
  /* ---------- TOP BAR ---------- */
}
.navbar__top {
  max-width: 1400px;
  margin: 0 auto;
  padding: clamp(4px, 1vw, 6px) clamp(15px, 3vw, 20px);
  display: flex;
  justify-content: flex-end;
  font-size: clamp(12px, 2.5vw, 14px);
  font-weight: 600;
}
@media (max-width: 576px) {
  .navbar__top {
    justify-content: center;
  }
}
.navbar .navbar__lang button {
  border: none;
  background: none;
  cursor: pointer;
  padding: clamp(4px, 1vw, 8px);
  font-size: clamp(12px, 2.5vw, 14px);
}
.navbar {
  /* ---------- PHONE BUTTON LOGIC ---------- */
}
.navbar .navbar__phone--desktop {
  display: flex;
  align-items: center;
  font-weight: 600;
  gap: clamp(6px, 1.5vw, 8px);
  font-size: clamp(14px, 2.5vw, 16px);
  color: #111827;
  text-decoration: none;
}
.navbar .navbar__phone--mobile {
  display: none;
}
@media (max-width: 768px) {
  .navbar .navbar__phone--desktop {
    display: none;
  }
  .navbar .navbar__phone--mobile {
    display: flex;
    margin-top: clamp(15px, 3vw, 20px);
    font-size: clamp(18px, 4vw, 20px);
    font-weight: 700;
    align-items: center;
    gap: clamp(8px, 2vw, 10px);
    color: #1e2150;
    text-decoration: none;
  }
}
.navbar {
  /* ---------- MAIN NAVBAR ---------- */
}
.navbar__bottom {
  padding: clamp(8px, 2vw, 10px) 0;
}
.navbar__container {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 clamp(15px, 3vw, 20px);
}
.navbar {
  /* ---------- LOGO ---------- */
}
.navbar__logo img {
  width: clamp(150px, 20vw, 200px);
  height: clamp(45px, 8vw, 60px);
  object-fit: contain;
  cursor: pointer;
}
@media (max-width: 768px) {
  .navbar__logo img {
    width: clamp(120px, 25vw, 160px);
    height: clamp(36px, 10vw, 48px);
  }
}
@media (max-width: 480px) {
  .navbar__logo img {
    width: clamp(100px, 30vw, 140px);
    height: clamp(30px, 12vw, 42px);
  }
}
.navbar {
  /* ---------- MENU ---------- */
}
.navbar__menu {
  display: flex;
  gap: clamp(20px, 4vw, 30px);
}
.navbar__menu a {
  position: relative;
  font-size: clamp(14px, 2.5vw, 16px);
  color: #111827;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
  /* underline */
}
.navbar__menu a::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -8px;
  width: 0%;
  height: 2px;
  background: #111827;
  border-radius: 2px;
  transition: 0.25s ease;
}
.navbar__menu a:hover {
  color: #111827;
}
.navbar__menu a:hover::after {
  width: 100%;
}
.navbar__menu a {
  /* ✅ ACTIVE LINK */
}
.navbar__menu a.active {
  color: #111827;
}
.navbar__menu a.active::after {
  width: 100%;
}
.navbar__menu {
  /* MOBILE MENU */
}
@media (max-width: 992px) {
  .navbar__menu {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: clamp(100px, 15vw, 120px);
    gap: clamp(20px, 4vw, 25px);
    opacity: 0;
    pointer-events: none;
    transform: translateY(-15px);
    z-index: 99999 !important;
    transition: all 0.35s ease;
  }
  .navbar__menu.open {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
  }
  .navbar__menu a {
    font-size: clamp(18px, 5vw, 22px);
    padding: clamp(8px, 2vw, 12px);
    /* mobile underline fix */
  }
  .navbar__menu a::after {
    bottom: -4px;
  }
}
@media (max-width: 576px) {
  .navbar__menu {
    padding-top: clamp(80px, 12vw, 100px);
    gap: clamp(15px, 3vw, 20px);
  }
  .navbar__menu a {
    font-size: clamp(16px, 6vw, 20px);
  }
}
.navbar {
  /* ---------- HAMBURGER ---------- */
}
.navbar .hamburger {
  display: none;
  flex-direction: column;
  gap: clamp(3px, 1vw, 5px);
  border: none;
  background: transparent;
  cursor: pointer;
  z-index: 100000 !important;
  padding: clamp(8px, 2vw, 12px);
}
.navbar .hamburger span {
  width: clamp(24px, 4vw, 28px);
  height: clamp(2px, 0.5vw, 3px);
  background: #1e2150;
  border-radius: 2px;
  transition: all 0.3s ease;
}
.navbar .hamburger.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}
.navbar .hamburger.active span:nth-child(2) {
  opacity: 0;
}
.navbar .hamburger.active span:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -6px);
}
@media (max-width: 992px) {
  .navbar .hamburger {
    display: flex;
  }
}
@media (max-width: 576px) {
  .navbar .hamburger {
    gap: clamp(2px, 0.8vw, 4px);
  }
}
.navbar {
  /* ---------- RESPONSIVE ADJUSTMENTS ---------- */
}
@media (max-width: 1024px) {
  .navbar__container {
    padding: 0 clamp(10px, 2vw, 15px);
  }
}
@media (max-width: 768px) {
  .navbar {
    border-radius: 0 0 clamp(12px, 2vw, 16px) clamp(12px, 2vw, 16px);
  }
  .navbar.scrolled {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
  }
}
@media (max-width: 576px) {
  .navbar {
    border-radius: 0 0 10px 10px;
  }
  .navbar__top {
    padding: 3px 10px;
  }
  .navbar__bottom {
    padding: 6px 0;
  }
  .navbar__container {
    padding: 0 10px;
  }
}
@media (max-width: 480px) {
  .navbar {
    border-radius: 0;
  }
  .navbar__container {
    padding: 0 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/styleHomePage/navbar.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGhB;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,4BAAA;EACA,iBAAA;AADF;AAGE;EACE,qCAAA;EACA,0CAAA;EACA,2BAAA;AADJ;AAVA;EAcE,kCAAA;AADF;AAEE;EACE,iBCiBQ;EDhBR,cAAA;EACA,oDAAA;EACA,aAAA;EACA,yBAAA;EACA,mCAAA;EACA,gBAAA;AAAJ;AAEI;EATF;IAUI,uBAAA;EACJ;AACF;AAEE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,mCAAA;AAAJ;AAlCA;EAqCE,6CAAA;AAAF;AACE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;EACA,mCAAA;EACA,cCrBG;EDsBH,qBAAA;AACJ;AAEE;EACE,aAAA;AAAJ;AAGE;EACE;IACE,aAAA;EADJ;EAIE;IACE,aAAA;IACA,kCAAA;IACA,iCAAA;IACA,gBAAA;IACA,mBAAA;IACA,0BAAA;IACA,cClDO;IDmDP,qBAAA;EAFJ;AACF;AAhEA;EAqEE,sCAAA;AAFF;AAGE;EACE,gCAAA;AADJ;AAIE;EACE,iBC1CQ;ED2CR,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iCAAA;AAFJ;AA9EA;EAmFE,+BAAA;AAFF;AAGE;EACE,gCAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AADJ;AAGI;EANF;IAOI,gCAAA;IACA,+BAAA;EAAJ;AACF;AAEI;EAXF;IAYI,gCAAA;IACA,+BAAA;EACJ;AACF;AAnGA;EAqGE,+BAAA;AACF;AAAE;EACE,aAAA;EACA,2BAAA;AAEJ;AAAI;EACE,kBAAA;EACA,mCAAA;EACA,cCtFC;EDuFD,qBAAA;EACA,gBAAA;EACA,2BAAA;EAEA,cAAA;AACN;AAAM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,mBCnGD;EDoGC,kBAAA;EACA,sBAAA;AAER;AACM;EACE,cCzGD;AD0GP;AACQ;EACE,WAAA;AACV;AA1BI;EA6BE,kBAAA;AAAN;AACM;EACE,cClHD;ADmHP;AACQ;EACE,WAAA;AACV;AAvCE;EA2CE,gBAAA;AADJ;AAEI;EA5CF;IA6CI,eAAA;IACA,MAAA;IACA,OAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,sCAAA;IACA,2BAAA;IAEA,UAAA;IACA,oBAAA;IACA,4BAAA;IAEA,yBAAA;IACA,0BAAA;EADJ;EAGI;IACE,UAAA;IACA,oBAAA;IACA,wBAAA;EADN;EAII;IACE,iCAAA;IACA,8BAAA;IAEA,yBAAA;EAHN;EAIM;IACE,YAAA;EAFR;AACF;AAMI;EAjFF;IAkFI,qCAAA;IACA,2BAAA;EAHJ;EAKI;IACE,iCAAA;EAHN;AACF;AA1LA;EAiME,oCAAA;AAJF;AAKE;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;EACA,8BAAA;AAHJ;AAKI;EACE,6BAAA;EACA,8BAAA;EACA,mBCjMO;EDkMP,kBAAA;EACA,yBAAA;AAHN;AAOM;EACE,4CAAA;AALR;AAQM;EACE,UAAA;AANR;AASM;EACE,8CAAA;AAPR;AAWI;EAhCF;IAiCI,aAAA;EARJ;AACF;AAUI;EApCF;IAqCI,2BAAA;EAPJ;AACF;AAjOA;EA2OE,iDAAA;AAPF;AAQE;EACE;IACE,iCAAA;EANJ;AACF;AASE;EAlPF;IAmPI,gEAAA;EANF;EAQE;IACE,yCAAA;EANJ;AACF;AASE;EA1PF;IA2PI,4BAAA;EANF;EAQE;IACE,iBAAA;EANJ;EASE;IACE,cAAA;EAPJ;EAUE;IACE,eAAA;EARJ;AACF;AAWE;EA1QF;IA2QI,gBAAA;EARF;EAUE;IACE,cAAA;EARJ;AACF","sourcesContent":["@use \"../variables\" as v;\r\n@use \"sass:color\";\r\n\r\n.navbar {\r\n  position: relative;\r\n  width: 100%;\r\n  z-index: 3000;\r\n  background: transparent;\r\n  border-radius: 0 0 20px 20px;\r\n  overflow: visible;\r\n\r\n  &.scrolled {\r\n    background: rgba(200, 200, 200, 0.93);\r\n    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.25);\r\n    backdrop-filter: blur(10px);\r\n  }\r\n\r\n  /* ---------- TOP BAR ---------- */\r\n  &__top {\r\n    max-width: v.$max-width;\r\n    margin: 0 auto;\r\n    padding: clamp(4px, 1vw, 6px) clamp(15px, 3vw, 20px);\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    font-size: clamp(12px, 2.5vw, 14px);\r\n    font-weight: 600;\r\n\r\n    @media (max-width: 576px) {\r\n      justify-content: center;\r\n    }\r\n  }\r\n\r\n  .navbar__lang button {\r\n    border: none;\r\n    background: none;\r\n    cursor: pointer;\r\n    padding: clamp(4px, 1vw, 8px);\r\n    font-size: clamp(12px, 2.5vw, 14px);\r\n  }\r\n\r\n  /* ---------- PHONE BUTTON LOGIC ---------- */\r\n  .navbar__phone--desktop {\r\n    display: flex;\r\n    align-items: center;\r\n    font-weight: 600;\r\n    gap: clamp(6px, 1.5vw, 8px);\r\n    font-size: clamp(14px, 2.5vw, 16px);\r\n    color: v.$dark;\r\n    text-decoration: none;\r\n  }\r\n\r\n  .navbar__phone--mobile {\r\n    display: none;\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    .navbar__phone--desktop {\r\n      display: none;\r\n    }\r\n\r\n    .navbar__phone--mobile {\r\n      display: flex;\r\n      margin-top: clamp(15px, 3vw, 20px);\r\n      font-size: clamp(18px, 4vw, 20px);\r\n      font-weight: 700;\r\n      align-items: center;\r\n      gap: clamp(8px, 2vw, 10px);\r\n      color: v.$brand-blue;\r\n      text-decoration: none;\r\n    }\r\n  }\r\n\r\n  /* ---------- MAIN NAVBAR ---------- */\r\n  &__bottom {\r\n    padding: clamp(8px, 2vw, 10px) 0;\r\n  }\r\n\r\n  &__container {\r\n    max-width: v.$max-width;\r\n    margin: 0 auto;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0 clamp(15px, 3vw, 20px);\r\n  }\r\n\r\n  /* ---------- LOGO ---------- */\r\n  &__logo img {\r\n    width: clamp(150px, 20vw, 200px);\r\n    height: clamp(45px, 8vw, 60px);\r\n    object-fit: contain;\r\n    cursor: pointer;\r\n\r\n    @media (max-width: 768px) {\r\n      width: clamp(120px, 25vw, 160px);\r\n      height: clamp(36px, 10vw, 48px);\r\n    }\r\n\r\n    @media (max-width: 480px) {\r\n      width: clamp(100px, 30vw, 140px);\r\n      height: clamp(30px, 12vw, 42px);\r\n    }\r\n  }\r\n\r\n  /* ---------- MENU ---------- */\r\n  &__menu {\r\n    display: flex;\r\n    gap: clamp(20px, 4vw, 30px);\r\n\r\n    a {\r\n      position: relative;\r\n      font-size: clamp(14px, 2.5vw, 16px);\r\n      color: v.$dark;\r\n      text-decoration: none;\r\n      font-weight: 500;\r\n      transition: color 0.3s ease;\r\n\r\n      /* underline */\r\n      &::after {\r\n        content: \"\";\r\n        position: absolute;\r\n        left: 0;\r\n        bottom: -8px;\r\n        width: 0%;\r\n        height: 2px;\r\n        background: v.$dark;\r\n        border-radius: 2px;\r\n        transition: 0.25s ease;\r\n      }\r\n\r\n      &:hover {\r\n        color:  v.$dark;\r\n\r\n        &::after {\r\n          width: 100%;\r\n        }\r\n      }\r\n\r\n      /* ✅ ACTIVE LINK */\r\n      &.active {\r\n        color: v.$dark;\r\n\r\n        &::after {\r\n          width: 100%;\r\n        }\r\n      }\r\n    }\r\n\r\n    /* MOBILE MENU */\r\n    @media (max-width: 992px) {\r\n      position: fixed;\r\n      top: 0;\r\n      left: 0;\r\n      width: 100vw;\r\n      height: 100vh;\r\n      background: #ffffff;\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: center;\r\n      padding-top: clamp(100px, 15vw, 120px);\r\n      gap: clamp(20px, 4vw, 25px);\r\n\r\n      opacity: 0;\r\n      pointer-events: none;\r\n      transform: translateY(-15px);\r\n\r\n      z-index: 99999 !important;\r\n      transition: all 0.35s ease;\r\n\r\n      &.open {\r\n        opacity: 1;\r\n        pointer-events: auto;\r\n        transform: translateY(0);\r\n      }\r\n\r\n      a {\r\n        font-size: clamp(18px, 5vw, 22px);\r\n        padding: clamp(8px, 2vw, 12px);\r\n\r\n        /* mobile underline fix */\r\n        &::after {\r\n          bottom: -4px;\r\n        }\r\n      }\r\n    }\r\n\r\n    @media (max-width: 576px) {\r\n      padding-top: clamp(80px, 12vw, 100px);\r\n      gap: clamp(15px, 3vw, 20px);\r\n\r\n      a {\r\n        font-size: clamp(16px, 6vw, 20px);\r\n      }\r\n    }\r\n  }\r\n\r\n  /* ---------- HAMBURGER ---------- */\r\n  .hamburger {\r\n    display: none;\r\n    flex-direction: column;\r\n    gap: clamp(3px, 1vw, 5px);\r\n    border: none;\r\n    background: transparent;\r\n    cursor: pointer;\r\n    z-index: 100000 !important;\r\n    padding: clamp(8px, 2vw, 12px);\r\n\r\n    span {\r\n      width: clamp(24px, 4vw, 28px);\r\n      height: clamp(2px, 0.5vw, 3px);\r\n      background: v.$brand-blue;\r\n      border-radius: 2px;\r\n      transition: all 0.3s ease;\r\n    }\r\n\r\n    &.active {\r\n      span:nth-child(1) {\r\n        transform: rotate(45deg) translate(5px, 5px);\r\n      }\r\n\r\n      span:nth-child(2) {\r\n        opacity: 0;\r\n      }\r\n\r\n      span:nth-child(3) {\r\n        transform: rotate(-45deg) translate(7px, -6px);\r\n      }\r\n    }\r\n\r\n    @media (max-width: 992px) {\r\n      display: flex;\r\n    }\r\n\r\n    @media (max-width: 576px) {\r\n      gap: clamp(2px, 0.8vw, 4px);\r\n    }\r\n  }\r\n\r\n  /* ---------- RESPONSIVE ADJUSTMENTS ---------- */\r\n  @media (max-width: 1024px) {\r\n    &__container {\r\n      padding: 0 clamp(10px, 2vw, 15px);\r\n    }\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    border-radius: 0 0 clamp(12px, 2vw, 16px) clamp(12px, 2vw, 16px);\r\n\r\n    &.scrolled {\r\n      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);\r\n    }\r\n  }\r\n\r\n  @media (max-width: 576px) {\r\n    border-radius: 0 0 10px 10px;\r\n\r\n    &__top {\r\n      padding: 3px 10px;\r\n    }\r\n\r\n    &__bottom {\r\n      padding: 6px 0;\r\n    }\r\n\r\n    &__container {\r\n      padding: 0 10px;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 480px) {\r\n    border-radius: 0;\r\n\r\n    &__container {\r\n      padding: 0 8px;\r\n    }\r\n  }\r\n}\r\n","// =========================\r\n// Typography\r\n// =========================\r\n$font-base: \"Noto Sans Armenian\",\r\n-apple-system,\r\nBlinkMacSystemFont,\r\n\"Segoe UI\",\r\nRoboto,\r\nOxygen,\r\nUbuntu,\r\nCantarell,\r\n\"Helvetica Neue\",\r\nsans-serif;\r\n\r\n// =========================\r\n// Brand Colors\r\n// =========================\r\n$brand-blue: #1e2150;\r\n$brand-green: #9eba44;\r\n\r\n// Base Colors\r\n$primary: $brand-blue;\r\n$secondary: $brand-green;\r\n$accent: #facc15;\r\n\r\n$light: #ffffff;\r\n$dark: #111827;\r\n$gray: #6b7280;\r\n$text-muted: #555;\r\n\r\n// Backgrounds\r\n$bg-light: #f9fafb;\r\n$bg-alt: #f0f0f5;\r\n$bg-gray: #f6f6f6;\r\n\r\n// Layout\r\n$max-width: 1400px;\r\n$layout-padding-x: 70px;\r\n\r\n// Spacing\r\n$spacing-xs: 0.25rem;\r\n$spacing-sm: 0.5rem;\r\n$spacing-md: 1rem;\r\n$spacing-lg: 2rem;\r\n$spacing-xl: 4rem;\r\n\r\n// Radius\r\n$radius-xs: 4px;\r\n$radius-sm: 8px;\r\n$radius-md: 12px;\r\n$radius-lg: 20px;\r\n$radius-round: 999px;\r\n\r\n// Shadows\r\n$shadow-medium: 0 4px 18px rgba(0, 0, 0, 0.15);\r\n\r\n// Transitions\r\n$transition-fast: 0.2s;\r\n$transition-normal: 0.3s;\r\n$transition-slow: 0.5s;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
